<template>
	<div class="theme-provider">
		<slot></slot>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'ThemeProvider',

	watch: {
		theme: {
			handler(theme) {
				document.body.setAttribute('data-theme', theme)
				this.$store.commit('setAppTheme', theme)
			},
			immediate: true
		}
	},

	computed: {
		...mapGetters({
			funnelType: 'location/getFunnelType'
		}),

		theme() {
			if (this.IS_FEMALE_FUNNEL_LIGHT_THEME_EXP) {
				return 'light'
			}
			return this.funnelType.theme ?? 'default'
		}
	}
}
</script>
